export default "__VITE_ASSET__DYd_DPYY__"